export { ssoRoutes as default } from '@/vue/features/sso/routes';
